module.exports = __webpack_public_path__ + "static/media/C_Hendrix_Sun.ca7dc748.jpg";